
import React, { useEffect, useState } from 'react'
import { Box, Button, Fab, IconButton, Link, Menu, MenuItem, Select, Tooltip, Typography } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu';
import { useDispatch, useSelector } from 'react-redux'
import AccountCircle from '@mui/icons-material/AccountCircle'
import { useLocation, useNavigate } from 'react-router'
import { clientlogoClear } from '../../reducers/reference_clientlogo'
import { userLogout } from '../../reducers/auth'
import { navmenuClear } from '../../reducers/reference_navmenu'
import { surveyClear } from '../../reducers/survey'
import { languageChange } from '../../actions/language'
import { setPersonLanguage } from '../../reducers/settings'
import { setPersonSessionVars } from '../../reducers/sessionvar'

const HeaderMenu = (props) => {
    const [anchorElNav, setAnchorElNav] = useState(null);
    const [anchorElUser, setAnchorElUser] = useState(null);

    const { user: currentUser, behalfOfUser: behalfOf } = useSelector((state) => state.auth);

    const au = useSelector((state) => state.auth);
    const navObj = useSelector(state => state.navmenu.fullobject)
    const navMenu = useSelector(state => state.navmenu.entities)
    //const translationDropdown = useSelector(state => state.translations.entities)
    //const translationData = useSelector(state => state.translations.additionalinfo)
    const navmenuStatus = useSelector(state => state.navmenu.status)
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const IsBehalf = behalfOf && behalfOf.AuthToken ? true : false
    const logoutToPage = au.logoutToPage


    const orgSettingsar = navObj.filter(x => { return x.OrganizationSettingValues })
    const orgSettings = orgSettingsar.length > 0 ? orgSettingsar[0] : {}
    
    const [language, setLanguage] = useState("")
    const [languageName, setLanguageName] = useState(props.languageName)

    useEffect(() => {

    }, [])

    // useEffect(() => {
    //     if (!language && languageName) {
    //         let lang = props.LanguageOptions.find(lang => lang.LanguageTypeKeyName === languageName)
    //         setLanguage(lang.LanguageTypeId)
    //         setMeasurement(lang.StandardId)
    //     }
    // },[languageName])
    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElUser(null);
    };

    const handleCloseUserMenu = event => {
        let { location } = event.currentTarget.dataset
        navigate(location)
        setAnchorElUser(null);
    };

    const handleLogout = (e) => {
        //e.preventDefault()
        dispatch(userLogout(currentUser))
        dispatch(clientlogoClear())
        dispatch(navmenuClear())
        dispatch(surveyClear())
        if (IsBehalf) {
            navigate('/participantmanagement')
        } else {
            navigate('/logout')
        }
    }
    // const handleLanguageChange = (e) => {
    //    const langobj = translationDropdown.filter(x=>{return x.LanguageTypeId === e.target.value})
       
    //     setLanguage(langobj[0].LanguageTypeName)
    //     dispatch(setPersonSessionVars({authToken:currentUser.AuthToken, SessionVarKeyName:"LANGUAGE",SessionVarValue:langobj[0].LanguageTypeKeyName}))
    //     dispatch(setPersonSessionVars({authToken:currentUser.AuthToken, SessionVarKeyName:"LANGUAGE ID",SessionVarValue:langobj[0].LanguageTypeId}))
    //     if (window !== undefined){
    //         window.location.reload(true)
    //     }
    // }
    return (
        <Box sx={{  }}>
            <Tooltip title={navMenu.MenuToolTip}>
                <Button variant="text" onClick={handleOpenUserMenu} sx={{ p: 0 }} aria-label="open menu drawer">
                    <MenuIcon fontSize='medium' aria-hidden="true" />

                </Button>
            </Tooltip>
            <Menu
                sx={{ mt: '45px', }}
                disableScrollLock={true}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseNavMenu}
                aria-haspopup="true"
                aria-controls="menu-appbar"
            >
                {location.pathname !== "/home" && navMenu && navMenu?.MenuProfileLabel && navMenu?.MenuHomeLabel !="" && (
                    <MenuItem onClick={handleCloseUserMenu} data-location="/home">
                        <Typography textAlign="center">{navMenu.MenuHomeLabel}</Typography>
                    </MenuItem>
                )}
                {location.pathname !== "/profile" && navMenu && navMenu?.MenuProfileLabel && navMenu?.MenuProfileLabel !="" && (
                    <MenuItem onClick={handleCloseUserMenu} data-location="/profile">
                        <Typography textAlign="center">{navMenu.MenuProfileLabel}</Typography>
                    </MenuItem>
                )}

                {currentUser
                    && currentUser.IsAdmin === true
                    && ['/participantmanagement', '/admincenterreports', '/groupmanagement'].indexOf(location.pathname) < 0
                    && (
                        <MenuItem onClick={handleCloseUserMenu} data-location="/participantmanagement">
                            <Typography textAlign="center">{navMenu.MenuAdminCenterLabel}</Typography>
                        </MenuItem>
                    )
                }

                {orgSettings
                    && orgSettings.OrganizationSettingValues
                    && orgSettings.OrganizationSettingValues['SHOW HEALTH SHELF']
                    && orgSettings.OrganizationSettingValues['SHOW HEALTH SHELF'] === "1"
                    && location.pathname !== "/healthshelf" && (

                        <MenuItem onClick={handleCloseUserMenu} data-location="/healthshelf">
                            <Typography textAlign="center">{navMenu.MenuHealthShelfLabel}</Typography>
                        </MenuItem>
                    )}

                {orgSettings
                    && orgSettings.OrganizationSettingValues
                    && orgSettings.OrganizationSettingValues['MEDIKEEPER ENABLED MENU']
                    && orgSettings.OrganizationSettingValues['MEDIKEEPER ENABLED MENU'] === "1"
                    && navMenu && navMenu.Visible && navMenu.Visible === '1'
                    && (
                        <MenuItem component="a" href={'../../../WsWebAppWellSuite/' + navMenu.MedikeeperURL}
                        >
                            <Typography textAlign="center">{navMenu.MenuHealthToolsLabel}</Typography>
                        </MenuItem>
                    )}


                {/* {
                    translationDropdown.length > 1 && (
                        <MenuItem >
                            <Select
                                variant="standard"
                                labelId="demo-simple-select-standard-label"
                                id="demo-simple-select-standard"
                                value={language}
                                onChange={handleLanguageChange}
                            >
                                {translationDropdown.map(l => (
                                    <MenuItem value={l.LanguageTypeId}>{l.LanguageTypeName}</MenuItem>
                                ))}
                            </Select>
                        </MenuItem>
                    )
                } */}
                <MenuItem onClick={() => handleLogout()}>
                    <Typography textAlign="center">{navMenu.MenuLogoutLabel} {IsBehalf ? "Of User" : ""}</Typography>
                </MenuItem>

            </Menu>

        </Box>
    )
}

export default HeaderMenu